exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loupe_eye-dropper_3gTfc {\n    position: absolute;\n    top: 0;\n    left: 0;\n    border-radius: 100%;\n    border: 1px solid #222;\n}\n\n[data-paint-theme=\"dark\"] .loupe_eye-dropper_3gTfc {\n    border-color: #888;\n}\n", ""]);

// exports
exports.locals = {
	"eye-dropper": "loupe_eye-dropper_3gTfc",
	"eyeDropper": "loupe_eye-dropper_3gTfc"
};